import { Injectable } from "@angular/core";
import * as Forge from 'node-forge';

@Injectable()
export class ForgeService {
  constructor() {}

  encryptWithPublicKey(valueToEncrypt: string, key: string): string {
    const rsa = Forge.pki.publicKeyFromPem(key);
    return window.btoa(rsa.encrypt(valueToEncrypt));
  }
}